import EnvironmentConfig from '../interfaces/EnvironmentConfig'

const qaConfigs: EnvironmentConfig = {
    dashboardUrl: 'https://dashboard.casaqa.ajira.tech',
    onboardingDashboardUrl: 'https://onboarding.qa.casaretail.ai',
    ruleServerUrl: 'https://api.casaqa.ajira.tech',
    apiServerUrl: 'https://api.customerstudioqa.ajira.tech',
    redmineUrl: 'https://redmine.casaretail.ai',
    casaWebAppUrl: 'https://web.casaqa.ajira.tech',
    casaEcomUrl: 'https://ecom.casaqa.ajira.tech',
    casaBeatUrl: 'https://beat-api.casaqa.ajira.tech',
    turnedOffFeatures: [],
    ruleUiUrl: 'https://rules.casaqa.ajira.tech',
    nifiUrl: 'https://nifi.casaqa.ajira.tech/connector-test',
    ruleServiceToken: 'Soop1kY7.WOW,2mR%qK[dGIi Y|s6+zteZ5{]:)>-%1j7~%q_r:,+n`(--F2^#+@',
    keycloakConfig: {
        url: `https://auth.qa.casaretail.ai/`,
        realm: `casa`,
        clientId: `casa_dashboard`,
    },
}

export default qaConfigs
